import { Subject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

export enum NetworkStates {
  CONNECTING,
  CONNECTED,
  DISCONNECTED,
}

@Injectable({
  providedIn: 'root',
})
export class NetworkStateService {
  public stateSubject: Subject<NetworkStates>;
  public state$: Observable<NetworkStates>;

  constructor() {
    this.stateSubject = new Subject();
    this.state$ = this.stateSubject.asObservable();
  }
}
